module.exports = "<nav class=\"navbar navbar-default\">\n  <div class=\"container-fluid\">\n    <!-- Brand and toggle get grouped for better mobile display -->\n    <div class=\"navbar-header brand\">\n      <a class=\"navbar-brand\" routerLink=\"/start\">\n        <span [innerHTML]=\"'titleBar.headline' | translate \" class=\"vcenter\"></span>\n      </a>\n    </div>\n  </div><!-- /.container-fluid -->\n</nav>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/title-bar/title-bar.component.html
// module id = ../../../../../src/app/title-bar/title-bar.component.html
// module chunks = main